export type AppEnvironment = 'production' | 'homologation' | 'development' | 'test';

const HOSTNAME_ENVIRONMENTS: Record<string, AppEnvironment> = {
  'app-homologacao.agro1.inf.br': 'homologation',
  localhost: 'development',
  web: 'homologation',
};

function resolveEnvironment(): AppEnvironment {
  const fromHostname = HOSTNAME_ENVIRONMENTS[window.location.hostname];
  if (fromHostname) return fromHostname;

  return import.meta.env.DEV ? 'development' : 'production';
}

export const USE_MOCK_API = import.meta.env.DEV && import.meta.env.VITE_MOCK_API === 'true';

export const APP_SYSTEM = 'sementes';

export const APP_SCOPE_HEADER = 'sementes';

export const APP_ENVIRONMENT = resolveEnvironment();

export const LABORATORY_API_URL =
  APP_ENVIRONMENT === 'production'
    ? 'https://integrations.aqila.com.br'
    : 'https://homologacao-integrations.aqila.com.br';
